export default "__VITE_ASSET__B75i1$M6__"